'use client';

import {ReactNode} from 'react';
import {useKey} from 'react-use';
import {ModalProps} from '../../providers';
import {Button} from '../Button';
import {Modal} from './Modal';

interface ModalConfirmProps extends ModalProps {
  title: string;
  message: ReactNode;
  labels: {
    cancel: ReactNode;
    confirm: ReactNode;
  };
  onConfirm?: () => Promise<void> | void;
}

export const ModalConfirm = ({title, message, labels, onConfirm, ...rest}: ModalConfirmProps) => {
  const onClickConfirm = async () => {
    await onConfirm?.();
    rest.onClose?.();
  };

  useKey('Enter', onClickConfirm);

  return (
    <Modal {...rest} hideCloseButton={true} closeOutside={false}>
      <h3 className="mb-2 font-semibold text-lg">{title}</h3>
      <div className="mb-4">
        <p className="text-sm text-text-muted">{message}</p>
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={rest.onClose}>
          {labels.cancel}
        </Button>
        <Button onClick={onClickConfirm}>{labels.confirm}</Button>
      </div>
    </Modal>
  );
};
